import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { apiService } from '@/services/api/apiService';
import { ReactNode } from 'react';

interface basicIngredientsFoodMenuSlice {
    ingredientId(ingredientId: any): unknown;
    ingredientName: ReactNode;
    foodMenuName: string | undefined;
    menuDescription: any;
    imageUrl: string | undefined;
    customDescription: any;
    id: string | number;
    isActive: boolean;
    basePrice: number;
    createdAt: string;
    dietTypeId: number;
    foodMenuId: string | number;
    auditTrailId: number | null;
    approvalStatusId: number;
}

interface basicIngredientsFoodMenuState {
    length: number;
    data: basicIngredientsFoodMenuSlice[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const URL = import.meta.env.VITE_API_COOK_URL;

export const basicIngredientsFoodMenu = createAsyncThunk<
    basicIngredientsFoodMenuSlice[],
    { foodMenuId: string | number },
    { rejectValue: string }
>(
    'basicIngredientsFoodMenu/fetchBasicIngredients',
    async ({ foodMenuId }, { rejectWithValue }) => {
        try {
            const config = {
                params: {
                    foodMenuId, // this becomes ?foodMenuId=11
                }
            };
            const response = await apiService.get<any>('get_basic_ingredient_by_food_menu_id', PORT, URL, config);
            return response.data;
        } catch (error: any) {
            console.error('API Error Details:', error.response?.data || error.message);
            return rejectWithValue('Failed to fetch basic ingredients');
        }
    }
);


const initialState: basicIngredientsFoodMenuState = {
    data: [],
    loading: false,
    error: null,
    length: 0
};

export const basicIngredientsFoodMenuSlice = createSlice({
    name: 'basicIngredientsFoodMenu',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(basicIngredientsFoodMenu.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                basicIngredientsFoodMenu.fulfilled,
                (state, action: PayloadAction<basicIngredientsFoodMenuSlice[]>) => {
                    state.loading = false;
                    state.data = action.payload;
                }
            )
            .addCase(basicIngredientsFoodMenu.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch food items';
            });
    },
});

export default basicIngredientsFoodMenuSlice.reducer;